// Normalise the Admin-Api GetSchoolMatProducts payload to the flat product array callers filter over.
//
// The Admin-Api response was enriched to a wrapper object
// { SchoolId, MatId, Products: [...], EiLevel, ProductCount } (staging). Older responses were a
// bare array. Callers read `x.Product` off each item, so both shapes must resolve to that same
// flat array — otherwise `data.filter(...)` throws on the object and product/audience detection
// silently fails. Casing-defensive; returns [] for anything unexpected.
export const extractProducts = data => {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.Products)) return data.Products
  if (Array.isArray(data?.products)) return data.products
  return []
}

export default extractProducts
